import { FC } from "react";

import { isSubmissionLate } from "../helpers";

import { SUBMISSION_ID_QUERY_PARAM } from "components/constants";
import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";
import { PageTabVariant } from "providers/DocViewProvider";
import { useCapabilities } from "store/capability-hooks";
import { pageSelectors, submissionSelectors } from "store/selectors";
import { useObjectSelector } from "store/store-hooks";
import { useQueryParam } from "utils/routing";

export type StudentLateSubmissionBannerProps = {
  pageId: string;
  selectedTabVariant?: PageTabVariant;
};

export const StudentLateSubmissionBanner: FC<StudentLateSubmissionBannerProps> = ({
  pageId,
  selectedTabVariant,
}) => {
  const { canParticipateInSection } = useCapabilities();
  const page = useObjectSelector((s) => pageSelectors.selectById(s, pageId), ["due_at"]);
  const submissionId = useQueryParam(SUBMISSION_ID_QUERY_PARAM);
  const submission = useObjectSelector(
    (s) => submissionSelectors.selectById(s, submissionId),
    ["created_at"],
  );
  const submissionIsLate = isSubmissionLate(submission, page?.due_at);

  const showStudentLateSubmissionBanner =
    submissionIsLate && canParticipateInSection && selectedTabVariant === "my_submission";

  if (!showStudentLateSubmissionBanner) {
    return null;
  }

  return (
    <Banner className="page-block-width" kind="info">
      {t("warning.late_submission_alert_student")}
    </Banner>
  );
};
